import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ViewTeamDetails = lazy(() =>
  import("../../../../../../../app-settings").then((module) => ({
    default: module.default.ViewTeamDetails,
  }))
);

export const viewTeamDetailsNRO: NavigationRoutingObject = {
  Component: ViewTeamDetails,
  componentFeatureFlippers: ["territories_v2"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("view-team-details-nro-heading", "View Team Details"),
  pageNameForTracking: () => "View Team Details",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("territories") && hasPermission("appGroup", { permission: "viewTeams" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/app_settings/app_settings/territories/:appGroupId",
};
